export default "__VITE_PUBLIC_ASSET__bf33c7fb__"